import type { Locale } from 'date-fns'
import { da, de, enGB, fr, nl, nlBE, sv } from 'date-fns/locale'
import { useIntl } from '@/intl'

const DATE_FNS_LOCALE_MAP: Record<string, Locale> = {
  'nl-NL': nl,
  'nl-BE': nlBE,
  'en-GB': enGB,
  'fr-FR': fr,
  'fr-BE': fr,
  'de-DE': de,
  'da-DK': da,
  'sv-SE': sv,
}

export function useDateFnsLocale(): Locale {
  const intl = useIntl()
  return DATE_FNS_LOCALE_MAP[intl.locale] ?? enGB
}
